import { Button, ButtonMode, Icon, ICONS, Loader, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { PropsWithChildren, ReactElement, useState } from 'react';
import { useGetContentHeight } from '../../hooks/layout';

import styles from './SidePanel.module.scss';

const cx = classNames.bind(styles);

interface SidePanelProps extends PropsWithChildren {
  noContentMessage?: string;
  isLoading?: boolean;
}

const SidePanel = ({ children, noContentMessage, isLoading }: SidePanelProps): ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const height = useGetContentHeight(true);

  const handleToggle = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <aside className={cx('body', { 'is-collapsed': isCollapsed })} data-testid="side-panel">
      {isLoading ? (
        <Loader position="center" />
      ) : (
        <div className={cx('sticky-container')} style={{ height: `${height}px` }}>
          <Tooltip content={isCollapsed ? 'Expand' : 'Collapse'}>
            <Button
              ariaLabel={isCollapsed ? 'expand side panel' : 'collapse side panel'}
              mode={ButtonMode.SECONDARY}
              onClick={handleToggle}
              className={cx('toggle')}
            >
              <Icon name={ICONS.CaretLeft} />
            </Button>
          </Tooltip>
          <div className={cx('content')}>
            {noContentMessage ? <p className={cx('no-content-message')}>{noContentMessage}</p> : children}
          </div>
        </div>
      )}
    </aside>
  );
};

export default SidePanel;
